import React from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import CopyDetailsToClipboard from 'legacy/src/utility/CopyDetailsToClipboard';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import defer from 'lodash/defer';

const CopyLinkAction = ({ detailsToBeCopied, onClick, disabled }) => {
  const ref = React.useRef();

  const onKeyDown = (event) => {
    // Enter and spacebar should activate copy
    if (event.keyCode === 13 || event.keyCode === 32) {
      event.stopPropagation();
      ref.current.click();
    }
  };

  return (
    <AccessibilityWrapper disableAutoFocus>
      <div
        tabIndex={0}
        role="button"
        aria-label="Copy Link"
        className="copy-details"
        onClick={onClick}
        onKeyDown={onKeyDown}
      >
        <CopyDetailsToClipboard
          text={detailsToBeCopied}
          notificationText="Assignment details copied to clipboard"
          customStyleClass="AccessibilityWrapper"
        >
          <SingleAction
            iconName="copy_link"
            ref={ref}
            onClick={(event) => {
              defer(() => onClick(event));
            }}
            disabled={disabled}
            tabIndex={-1}
          >
            <span className="item-text">Copy Link</span>
          </SingleAction>
        </CopyDetailsToClipboard>
      </div>
    </AccessibilityWrapper>
  );
};

export default CopyLinkAction;
